import { useAppAlert } from '@/layouts/AppAlertProvider.tsx'

const usePermissionAlert = () => {
  const { fireAlert } = useAppAlert()

  const showPermissionDeniedMessage = async () => {
    await fireAlert({
      variant: 'error',
      message:
        'You do not have the required permissions to perform this action.',
    })
  }

  return { showPermissionDeniedMessage }
}

export default usePermissionAlert
